import React, { useState,useEffect }  from 'react';
import {Link} from 'react-router-dom'
import axios from 'axios';

import { BASE_URL } from '../Config/Base';

import { Oval } from  'react-loader-spinner'
import _ from 'lodash'

const pageSize =5;
const TecAddressMain = () => {


  useEffect(()=>{ 
    document.getElementById("PopAAdd").style.display="none"
    document.getElementById("PopATable").style.display="none"
    getTecAddress()
    setpop(true);
    setTimeout(() => {
            
      getroleAction() 
      
       }, 1000);
    setTimeout(() => {
            
      setpop(false);
      getAssignedAction()
    
        
       }, 2000);


   
  }, [])
  const[pop,setpop] = useState(false);
  let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken')); 

  const [sectionAddress, setSectionAddress] = useState([])
  const [EditSectionAddress, setEditSectionAddress] =useState([])
  const [paginatedPosts, setpaginatedPosts] = useState();
  const [currentPage, setcurrentPage] = useState(1);
 ///getTecAddress


 function getTecAddress()
 {


 fetch(`${BASE_URL}/Tec/GettecAddress`, {

   method: 'GET',

   headers: {

     "Content-type": "application/json",

     "Accept": "application/json",

     

     "Access-Control-Allow-Headers": "Access-Control-Request-Headers "

   },

   //body:JSON.stringify(data)

 }).then(response => response.json())

   .then(data => {
     console.log("DatasectionA", data);
     setSectionAddress(data)
     setpaginatedPosts(_(data).slice(0).take(pageSize).value());
       }
   );



     }
     const pageCount = sectionAddress? Math.ceil(sectionAddress.length/pageSize) :0;
     // if (pageCount === 1)
     // return null;
     
     const pages = _.range(1, pageCount+1)
     
     const pagination =(pageNo)=>{
     setcurrentPage(pageNo);
     const startIndex = (pageNo - 1) * pageSize;
     const paginatedPost = _(sectionAddress).slice(startIndex).take(pageSize).value();
     setpaginatedPosts(paginatedPost)
     }
     const onNext = () => {


       pagination(currentPage + 1);
     };
   
     const onPrevious = () => {
       pagination(currentPage - 1);
     };

       ///submitsectionAddress


 
   // console.log(file)
   
  
 
   function submitsectionAddress(){


    var UserId= localStorage.getItem('UserId')
     var BranchName = document.getElementById("BranchName").value;
     var No = document.getElementById("No").value;
     var Address = document.getElementById("Address").value;
     var Street = document.getElementById("Street").value;
     var Location= document.getElementById("Location").value;
     const Mobile1 = /^[0-9]{10}$/;
      

     if(!BranchName){

       document.getElementById("AddErrA").innerHTML="BranchName Required"

     }
     else if(BranchName){

       document.getElementById("AddErrA").innerHTML=" "

     }
     if(!No){

      document.getElementById("AddErrB").innerHTML="No Required"

    }
    else if (Mobile1.test(No)===false){

      document.getElementById("AddErrB").innerHTML="Enter Valid Mobile No"
      
    }
    else{

      document.getElementById("AddErrB").innerHTML=" "

    }
    if(!Address){

      document.getElementById("AddErrC").innerHTML="Address Required"

    }
    else if(Address){

      document.getElementById("AddErrC").innerHTML=" "

    }
    if(!Street){

      document.getElementById("AddErrD").innerHTML="Street Required"

    }
    else if(Street){

      document.getElementById("AddErrD").innerHTML=" "

    }
    if(!Location){

      document.getElementById("AddErrE").innerHTML="Location Required"

    }
    else if(Location){

      document.getElementById("AddErrE").innerHTML=" "

    }
     
   

     if(BranchName && (Mobile1.test(No)===true) && Address && Street && Location ){



    const body =
     {
       
      BranchName:BranchName, 

       No:No,
       Address:Address,
       Street:Street,
       Location:Location,
       ActiveStatus:0,
       DeleteStatus:0,
       CreatedBy:UserId


        
     
     }
     console.log('body',body);

   
     axios({
            method:"POST",
            url :`${BASE_URL}/Tec/AddtecAddress`,
            data:body, 
            headers: {
                 "Content-Type": "multipart/form-data",
                 'Authorization':bearer 
             }     
         }) 
 
        .then((response) =>{
        console.log(response.data);
   
   
        if(response.data.status === "Success"){
          
             setSuccessToast(true)
           
          
             setTimeout(() => {
             
              getTecAddress()
              setSuccessToast(false)
              closeAddressAddForm()
             }, 2000);
           }

   
     })
     .catch(error => {
       console.log(error);
       alert("failed !")
     

     })
       
   }

   }


 ////Get Particular Data PostMethodAddress

 function editSectionAddress(Id){

  SelectParticular(Id)
  document.getElementById("AddressEditPop").style.display = "block";
  
}
  function SelectParticular(Id){
    const body =
      {
   
      id:Id
      }
    console.log('body',body);


 axios({
        method:"POST",
        url :`${BASE_URL}/Tec/EdittecAddress`,
        data:body, 
        headers: {
             "Content-type": "application/json",
             'Authorization':bearer 
         }     
     }) 
     

     .then((response) =>{
       console.log(JSON.stringify(response.data));
  
   
       setEditSectionAddress(response.data)

      
  
    })
    .catch(error => {
      console.log(error);
      
    })

 }


 function updateSectionAddress(Id){

  var UserId= localStorage.getItem('UserId')
    var BranchName = document.getElementById("EBranchName").value;
     var No = document.getElementById("ENo").value;
     var Address = document.getElementById("EAddress").value;
     var Street = document.getElementById("EStreet").value;
     var Location= document.getElementById("ELocation").value;
     const Mobile1 = /^[0-9]{10}$/;

     if(!BranchName){

       document.getElementById("ErrA").innerHTML="BranchName Required"

     }
     else if(BranchName){

       document.getElementById("ErrA").innerHTML=" "

     }
     if(!No){

      document.getElementById("AddErrB").innerHTML="No Required"

    }
    else if (Mobile1.test(No)===false){

      document.getElementById("AddErrB").innerHTML="Enter Valid Mobile No"
      
    }
    else{

      document.getElementById("AddErrB").innerHTML=" "

    }
    if(!Address){

      document.getElementById("ErrC").innerHTML="Address Required"

    }
    else if(Address){

      document.getElementById("ErrC").innerHTML=" "

    }
    if(!Street){

      document.getElementById("ErrD").innerHTML="Street Required"

    }
    else if(Street){

      document.getElementById("ErrD").innerHTML=" "

    }
    if(!Location){

      document.getElementById("ErrE").innerHTML="Location Required"

    }
    else if(Location){

      document.getElementById("ErrE").innerHTML=" "

    }
     
   

     if(BranchName && No && Address && Street && Location ){



         const body =
        {
         Id:Id,
      BranchName:BranchName, 

        No:No,
       Address:Address,
       Street:Street,
       Location:Location,
       
       EditedBy:UserId


   

}
console.log('body',body);


axios({
       method:"POST",
       url :`${BASE_URL}/Tec/UpdatetecAddress`,
       data:body, 
       headers: {
            "Content-Type": "multipart/form-data",
            'Authorization':bearer 
        }     
    }) 

   .then((response) =>{
   console.log(response.data);


   if(response.data.status === "Success"){
   
    setUpdateToast(true)
    closeAddressEditForm()
        setTimeout(() => {
          setcurrentPage(1)
         getTecAddress()
         setUpdateToast(false)
        
        }, 2000);
      }

})
.catch(error => {
  console.log(error);
 alert("failed !")

})
  

}

}

 ///DeleteSectionA


 function ConfirmDelete(Id){

  SelectParticular(Id)
  setTimeout(() => {
    document.getElementById("modaldeleteForm").style.display = "block";
  },1000);

}

 function DeleteSectionAddress(Id){

 


 const body =
  {
    Id:Id,
 
   

     
  
  }
  console.log('body',body);


  axios({
         method:"POST",
         url :`${BASE_URL}/Tec/DeletetecAddress`,
         data:body, 
         headers: {
            "Content-type": "application/json",
              'Authorization':bearer 
          }     
      }) 

     .then((response) =>{
     console.log(response.data);


     
     closeForm()
     setDeleteErrToast(true)
        
          setTimeout(() => {
            setDeleteErrToast(false)
           getTecAddress()
           setcurrentPage(1)
           
          }, 2000);
         
          
        

  })
  .catch(error => {
    console.log(error);
    alert("failed !")
  
  })
    
 



}
//function closeform

function closeForm(){

  document.getElementById("modaldeleteForm").style.display ="None"

}
//closeAddFormAddress

function closeAddressAddForm(){



 

  document.getElementById("AddErrA").innerHTML=" "

  document.getElementById("AddErrB").innerHTML=" "
  document.getElementById("AddErrC").innerHTML=" "
  document.getElementById("AddErrD").innerHTML=" "
  document.getElementById("AddErrE").innerHTML=" "
  document.getElementById("tecform").reset();
         
  document.getElementById("AddressAddPop").style.display = "none";
 
 
}

 //closeEditForm

 function closeAddressEditForm(){


  document.getElementById("ErrA").innerHTML=" "
  document.getElementById("ErrB").innerHTML=" "
  document.getElementById("ErrC").innerHTML=" "
  document.getElementById("ErrD").innerHTML=" "
  document.getElementById("ErrE").innerHTML=" "
  document.getElementById("teceditform").reset();

  
  document.getElementById("AddressEditPop").style.display = "none";
 }

  //OpenAddForm

  function openAddressForm(){

    document.getElementById("AddressAddPop").style.display = "block";

  }

  function getroleAction(){


    let LoginRole= localStorage.getItem("Role");
    
   
    console.log('checkrole',LoginRole);
    const body =
    {
      
     role:LoginRole
    }
    console.log('body',body);
   
   
    axios({
           method:"POST",
           url :`${BASE_URL}/Tec/GetTecRoleAction`,
           data:body, 
           headers: {
                "Content-type": "application/json",
                "Authorization": bearer,
            }     
        }) 
        
   
        .then((response) =>{
          console.log(response.data);
     
       
       
                
          localStorage.setItem("LoginAction",JSON.stringify(response.data))
          localStorage.getItem("LoginAction");
       })
       .catch(error => {
         console.log(error);
   })
   }
   
   const[editicon,setediticon] = useState(false);
   const[delicon,setdelicon] = useState(false);
   const[denied,setdenied] = useState(false);     
    function getAssignedAction(){
   
   
   
     ////Admin
       
       let LoginRoleId= localStorage.getItem("RoleId");
   
       let CheckSAdmin = LoginRoleId.includes("00")
       let CheckAdmin =LoginRoleId.includes("01")
   
   
     /////////////Teammate
       let LoginAction =  localStorage.getItem("LoginAction");
       let TecRoleAction =  JSON.parse(LoginAction);
       let roleAction = TecRoleAction.map((e)=>e.roleAction);
       console.log(roleAction);
       
       let roles = roleAction.toString();
       let roleResult = roles.includes('Add')
       console.log(roleResult)
       
       let roleResultA = roles.includes('View')
       console.log(roleResultA)
       
       let roleResultB = roles.includes('Edit')
       console.log(roleResultB)
       
       let roleResultC = roles.includes('Delete')
       console.log(roleResultC)
   
   
      
   
       if(roleResult==true && CheckSAdmin==false && CheckAdmin==false){
   
         document.getElementById('PopAAdd').style.display ="block";
       }
       else if(CheckSAdmin==true || CheckAdmin==true){
         document.getElementById('PopAAdd').style.display ="block";
       }
       else{
         document.getElementById('PopAAdd').style.display ="none";
   
       }
       if(roleResultA==true  && CheckSAdmin==false && CheckAdmin==false){
   
         document.getElementById('PopATable').style.display ="block";
       }
       else if(CheckSAdmin==true || CheckAdmin==true){
         document.getElementById('PopATable').style.display ="block";
       }
       else{
         document.getElementById('PopATable').style.display ="none";
   
       }
       if(roleResultB==true  && CheckSAdmin==false && CheckAdmin==false){
     
         setediticon(true)
       }
       else if(CheckSAdmin==true || CheckAdmin==true){
         setediticon(true)
       }
       else{
         setediticon(false)
   
       }
       if(roleResultC==true  && CheckSAdmin==false && CheckAdmin==false){
   
         setdelicon(true)
       }
       else if(CheckSAdmin==true || CheckAdmin==true){
         setdelicon(true)
       }
       else{
         setdelicon(false)
   
       }
   
       if(roleResultB==false  && roleResultC==false && CheckSAdmin==false && CheckAdmin==false){
   
         setdenied(true)
       }
       else{
   
         setdenied(false)
       }

       
    if( roleResultA==false && CheckSAdmin==false && CheckAdmin==false){
      document.getElementById("TecActionDenied").innerHTML="View Table is not Assigned"
       }
     }
     const[SuccessToast,setSuccessToast] = useState(false);  
     const[UpdateToast,setUpdateToast] = useState(false);  
     const[DeleteToast,setDeleteErrToast] = useState(false);

  return (
    <div className='tec-addmain'>
      
   
        
  <div className="tec-addgrid-layout">
  <div className="tec-addmain-top">
 
 <p><span id="tectopspan"><span id="TecTitleMain">ADDRESS</span> </span>
  <div className='tec-addmain-back'>
 <Link to='/TecTalk'><i class="fa fa-angle-double-left" aria-hidden="true" id="tecbackicon"></i></Link>
 </div>
 </p> 

 {/* <hr></hr> */}
 </div>
  </div>

  {/* Toast */}
  {SuccessToast? <div className='tec-toastpop-fade'>
      <div className="modal-dialog" role="document">
      <div id='tecToastcontainer' style={{left:"20%"}}>
    <div id="Tec-success-box">
    <div className="Tec-Toastdot"></div>
    <div className="Tec-Toastdot Tec-Toasttwo"></div>
    <div className="Tec-Toastface">
      <div className="Tec-Toasteye"></div>
      <div className="Tec-Toasteye Tec-Toastright"></div>
      <div className="Tec-Toastmouth Tec-Toasthappy"></div>
    </div>
    <div className="Tec-Toastshadow scale"></div>
    <div className="Tec-Toastmessage"><h1 class="Tec-Toastalert">Success!</h1><p>Added Successfully</p></div>
   
  </div></div></div></div>:null}
   {/* Toast */}
  {DeleteToast? <div className='tec-toastpop-fade'>
      <div className="modal-dialog" role="document">
      <div id='tecToastcontainer' style={{left:"20%"}}>
    <div id="Tec-success-box">
    <div className="Tec-Toastdot"></div>
    <div className="Tec-Toastdot Tec-Toasttwo"></div>
    <div className="Tec-Toastface">
      <div className="Tec-Toasteye"></div>
      <div className="Tec-Toasteye Tec-Toastright"></div>
      <div className="Tec-Toastmouth Tec-Toasthappy"></div>
    </div>
    <div className="Tec-Toastshadow scale"></div>
    <div className="Tec-Toastmessage"><h1 class="Tec-Toastalert">Success!</h1><p>Deleted Successfully</p></div>
   
  </div></div></div></div>:null} 


   {/* Toast */}
   {UpdateToast? <div className='tec-toastpop-fade'>
      <div className="modal-dialog" role="document">
      <div id='tecToastcontainer' style={{left:"20%"}}>
    <div id="Tec-success-box">
    <div className="Tec-Toastdot"></div>
    <div className="Tec-Toastdot Tec-Toasttwo"></div>
    <div className="Tec-Toastface">
      <div className="Tec-Toasteye"></div>
      <div className="Tec-Toasteye Tec-Toastright"></div>
      <div className="Tec-Toastmouth Tec-Toasthappy"></div>
    </div>
    <div className="Tec-Toastshadow scale"></div>
    <div className="Tec-Toastmessage"><h1 class="Tec-Toastalert">Success!</h1><p>Updated Successfully!</p></div>
   
  </div></div></div></div>:null}

  <div className='tec-addmain-add' id="PopAAdd">
      <button className='add-user' onClick={openAddressForm}>  Add Address</button>
 </div>
     <div>

      
    {/* EditAddress */}
<div className='tech-pop-fade' id="AddressEditPop">
{EditSectionAddress.map((e)=>{
return<div className="modal-dialog" role="document">
<div className="modal-content" >
 <div className="modal-header text-center">
   <h4 className="modal-title w-100 font-weight-bold">EDIT SECTION</h4>
   <button type="button" className="close" onClick={closeAddressEditForm}>
     <span aria-hidden="true">&times;</span>
   </button>
 </div>
 <form  id="teceditform" onSubmit={()=>updateSectionAddress(e.id)}>
 <div className="modal-body mx-3">
 <div className="md-form mb-5">
      
      <label id="sectionlable">BranchName</label> 
        <input type="text" id="EBranchName" defaultValue={e.branchName}/>
        <span id="ErrA" className='error'></span>
      </div> 
      <div className="md-form mb-5">
         
      <label id="sectionlable">Mobile No</label> 
        <input type="text" id="ENo" defaultValue={e.no}/>
        <span id="ErrB" className='error'></span>
      </div> 
      <div className="md-form mb-5">
         
      <label id="sectionlable">Street</label> 
        <input type="text" id="EStreet" defaultValue={e.street}/>
        <span id="ErrD" className='error'></span>
      </div> 
      <div className="md-form mb-5">
         
         <label id="sectionlable">Address</label> 
           <textarea type="text" id="EAddress" defaultValue={e.address}/>
           <span id="ErrC" className='error'></span>
         </div> 
      
      <div className="md-form mb-5">
         
      <label id="sectionlable">Location</label> 
        <input type="text" id="ELocation" defaultValue={e.location}/>
        <span id="ErrE" className='error'></span>
      </div> 
     
  
 </div>
 <div className="modal-footer d-flex justify-content-center">
   <button className='tec-adduser-button' type="submit">Update</button>
 </div>
 </form>
</div>
</div>})}

</div>

{/* AddAddress */}
<div className='tech-pop-fade' id="AddressAddPop">

<div className="modal-dialog" role="document">
<div className="modal-content">
 <div className="modal-header text-center">
   <h4 className="modal-title w-100 font-weight-bold">ADD SECTION</h4>
   <button type="button" className="close" onClick={closeAddressAddForm}>
     <span aria-hidden="true">&times;</span>
   </button>
 </div>
 <form  id="tecform" onSubmit={submitsectionAddress} >
 <div className="modal-body mx-3">
   <div className="md-form mb-5">
      
   <label id="sectionlable">BranchName</label> 
     <input type="text" id="BranchName"/>
     <span id="AddErrA" className='error'></span>
   </div> 
   <div className="md-form mb-5">
      
   <label id="sectionlable">Mobile No</label> 
     <input type="text" id="No"/>
     <span id="AddErrB" className='error'></span>
   </div> 
 
   <div className="md-form mb-5">
      
   <label id="sectionlable">Street</label> 
     <input type="text" id="Street"/>
     <span id="AddErrD" className='error'></span>
   </div> 
   <div className="md-form mb-5">
      
      <label id="sectionlable">Address</label> 
        <textarea type="text" id="Address"/>
        <span id="AddErrC" className='error'></span>
      </div> 
   <div className="md-form mb-5">
      
   <label id="sectionlable">Location</label> 
     <input type="text" id="Location"/>
     <span id="AddErrE" className='error'></span>
   </div> 
  
 
 </div>
 <div className="modal-footer d-flex justify-content-center">
   <button className='tec-adduser-button' type="submit">Add</button>
 </div>
 </form>
</div>
</div>

</div> 



     <div className='tec-sectionMain'  id="PopATable">
  
     {
   sectionAddress.length==0? (<div id="TecApiFail">" No Data Found "</div>):(
<div>
<div className='tectable'>

<div class="tec-table_responsive">
<table>
<thead>
<tr>

 <th>Branch</th>
 <th>Location</th>
 <th>Address</th>
 <th>Mobile</th>
 <th>Action</th>
</tr>
</thead>
<tbody>
{paginatedPosts.map((e)=>{


return<tr>
  

<td>{e.branchName}</td>
<td><div style={{inlineSize:"150px",overflowWrap:"break-word",wordWrap:"break-word"}}>{e.location}</div></td>
<td><div style={{inlineSize:"150px",overflowWrap:"break-word",wordWrap:"break-word"}}>{e.street},{e.address}</div>
</td>
<td>{e.no}</td>

<td style={{whiteSpace:"nowrap"}} >
{editicon?<span><i class="fa fa-pencil" aria-hidden="true" onClick={()=>editSectionAddress(e.id)} id="tecEditicon"></i></span>:null} &nbsp;&nbsp;
  {delicon?<span><i class="fa fa-trash" aria-hidden="true" onClick={()=>ConfirmDelete(e.id)} id="tecDelicon"></i></span>:null}
  {denied?<span className='error'>Denied</span>:null}
  </td>
</tr>
} )}
</tbody>
</table>
</div>
</div>

<br></br>
{pageCount==1?null:<nav  id="tecpagenav">
    <ul className='pagination'>
   
       
       {currentPage >1?<li className="page-item">
              <a class="tecpage-link" onClick={onPrevious} aria-label="Next">
                <span aria-hidden="true">&laquo;</span>
                <span class="sr-only">Previous</span>
              </a>
            </li>:null}
            &nbsp; &nbsp;
            <span style={{marginTop:"6px"}}>
         Page {currentPage} Of {pageCount} 
         
            </span>   &nbsp; &nbsp;
        {currentPage<pageCount?<li className="page-item">
              <a class="tecpage-link" onClick={onNext} aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
                <span class="sr-only">Next</span>
              </a>
            </li>:null}


            </ul>
  </nav>}
</div>
)}




</div>

     </div>
 

     {pop? <div id="Loader">
<Oval
  height={40}
  width={50}

  color="black"
  wrapperStyle={{}}
  wrapperClass=""
  visible={true}
  ariaLabel='oval-loading'
  secondaryColor="gray"
  strokeWidth={2}
  strokeWidthSecondary={2}

/>
     </div>
 :null}
{EditSectionAddress.map((e)=>{ 
   return<div className="tec-pop-fade" id="modaldeleteForm" tabindex="-1" role="dialog">
     <div className="modal-dialog" role="document">
      <div className="modal-content" style={{marginTop:"240px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">! Warning</h4>
        <button type="button" className="close" onClick={closeForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

    <form id='form'>

     <div className="modal-body mx-3">

        <div className="md-form mb-4">
            <div className='text-center'>
          <h5 style={{marginTop:"25px"}}>Are you sure want to Delete <span>{e.userName}</span> ?</h5>
          </div>
        </div>

      </div>

       <div className="modal-footer d-flex justify-content-center">
       <button className="tec-adduser-button" onClick={()=>DeleteSectionAddress(e.id)} type='submit'>Delete</button>
        <button className="tec-adduser-button" onClick={closeForm} type='submit'>Cancel</button>
       </div>

       </form>
      
     </div>
    </div>
</div>})}

<div id="TecDenied">
   <span id="TecActionDenied"></span>

   </div>
    </div>
  )
}

export default TecAddressMain
